export const sites = {
  Add_new_site: "Add new site",
  Address: "Address",
  Address_1: "Address 1",
  Address_2: "Address 2",
  All_sites: "All sites",
  Applicability: "Applicability",
  Basic_information: "Basic information",
  City: "City",
  "Country_*": "Country *",
  Create_assessment: "Create assessment",
  Create_new_site: "Create new site",
  edit: "Edit",
  Edit_site_details: "Edit site details",
  upload_your_templates: "Upload filled site templates",
  Here_you_can_manage_all_sites_in_your_organization: "Here you can manage all sites in your organization",
  "Name_*": "Name *",
  Postcode: "Postcode",
  Release_to_drop_the_files_here: "Release to drop the files_here",
  "Relevant_standard_*": "Relevant standard *",
  Save_site: "Save site",
  "Scope_of_applicability_*": "Scope of applicability *",
  "Site_coordinator_*": "Site coordinator *",
  siteCoordinator: "Site Coordinator",
  siteName: "Site Name",
  Standard_Body: "Standard Body",
  Standards: "Standards",
  State: "State",
  Template: "Template",
  create_site_from_template: "Create a site from a template file",
  You_can_upload_many_sites_in_the_same_file: "You can upload many sites in the same file",
} as const;
